// ── where the creature sits, per width ──────────────────────────────────────
// THE READER LAW says the words own the left and the creature owns the right.
// That law has a viewport in it that nobody wrote down: it is true when there
// IS a right — a column of prose with a field of ground beside it. On a phone
// there is no such field. The prose runs the full width, so a right-anchored
// netti at -6vw sits directly underneath the sentences, and the horizontal band
// ramp that protects it on a desktop (`--co-band-across`) is protecting a strip
// of screen the words are standing on.
//
// So on a narrow screen the creature does what it already does on the docs
// reader, the dashboard and a space home: it goes to the BOTTOM CENTRE, under
// the column rather than behind it.
//
// And it goes back UNDER the veil. On a desktop netti rides above the scrim
// (z2) so it stays sharp while you read, because it is off to the side where it
// costs nothing. On a phone the same z-order would put a lit organism on top of
// the frost and under the text, and the text is what has to win.

export type ReaderOrg = {
  anchor: "bottom";
  offset: { y: string };
  /** below `.co-read-scrim` (z1) — the veil is above the creature here. */
  zIndex: number;
};

export const READER_ORG_NARROW: ReaderOrg = {
  anchor: "bottom",
  offset: { y: "-2vh" },
  zIndex: 0,
};

/** the wide default the reader surfaces share: beside the words, above the veil. */
export const READER_ORG_WIDE = {
  anchor: "right" as const,
  offset: { x: "-6vw" },
  zIndex: 2,
};

/** an index page seats the creature a little further in than a reader does. */
export const INDEX_ORG_WIDE = {
  anchor: "right" as const,
  offset: { x: "2%", y: "0%" },
  zIndex: 2,
};

export function readerOrg(isNarrow: boolean, wide: { anchor: "right"; offset: Record<string, string>; zIndex: number }) {
  return isNarrow ? READER_ORG_NARROW : wide;
}

/** law_full_bloom (2026-09-26) — on the public commons and company surfaces
 *  (community, guides, skills, the company index and its posts) netti is ALWAYS
 *  fully realised: fully grown, sharp, never frosted, never aged by the scroll,
 *  never rested by the calm bus. Growing and fading are for surfaces where the
 *  creature is a live reading of activity (the dashboard's feeds, the reader of
 *  your own memory), not for a place someone came to look at. */
export const FULL_BLOOM_AGE = 1;
